import { useState, FormEvent } from "react";
import { Button } from "@/components/ui/button";

const PROFESSOR_PASSWORD = "IESSA2026@@";

const Professores = () => {
  const [password, setPassword] = useState("");
  const [hasAccess, setHasAccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (password === PROFESSOR_PASSWORD) {
      setHasAccess(true);
      setError("");
    } else {
      setHasAccess(false);
      setError("Senha incorreta. Tente novamente.");
    }
  };

  return (
    <section className="section-shell">
      <header className="mb-10 max-w-2xl space-y-3">
        <p className="section-title">Área do Docente</p>
        <h1 className="section-heading">Acesso exclusivo para professores.</h1>
        <p className="section-subtitle">
          Esta página é destinada apenas aos docentes do Instituto. Informe a senha para visualizar os acessos
          acadêmicos.
        </p>
      </header>

      {!hasAccess ? (
        <form onSubmit={handleSubmit} className="card-ambient max-w-md space-y-4 p-6">
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground" htmlFor="professor-password">
              Senha de acesso
            </label>
            <input
              id="professor-password"
              type="password"
              className="input-base w-full"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Digite a senha fornecida pelo Instituto"
            />
            {error && <p className="text-xs text-destructive">{error}</p>}
            <p className="text-xs text-muted-foreground">
              Em caso de dúvidas ou perda da senha, entre em contato com a secretaria do Instituto.
            </p>
          </div>

          <Button type="submit" className="w-full btn-pill-lg">
            Entrar
          </Button>
        </form>
      ) : (
        <div className="card-ambient max-w-md space-y-4 p-6">
          <p className="text-sm text-muted-foreground">
            Utilize os botões abaixo para acessar rapidamente os sistemas acadêmicos.
          </p>

          <div className="space-y-3">
            <Button asChild className="w-full btn-pill-lg">
              <a href="https://iessa.vercel.app/CadastroNotas" target="_blank" rel="noreferrer">
                Lançar Notas (Exclusivo para Docentes)
              </a>
            </Button>
            <Button asChild className="w-full btn-pill-lg">
              <a href="https://iessa.vercel.app/BoletimBasico" target="_blank" rel="noreferrer">
                Cadastrar Alunos (Exclusivo para Docentes)
              </a>
            </Button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Professores;
